// src/services/apiService.js
import fetch from "./FetchApiUtils";
import config from "./EndpointConfig";

const ServiceApi = {
  register: (data) =>
    fetch(
      `${config.BACKEND_HOST_PACK_SERVICE}/register`,
      "post",
      null,
      data,
      null
    ),
  extend: (data) =>
    fetch(
      `${config.BACKEND_HOST_PACK_SERVICE}/extend`,
      "post",
      null,
      data,
      null
    ),
  detail: (type) =>
    fetch(
      `${config.BACKEND_HOST_PACK_SERVICE}/?reason=${type}`,
      "get",
      null,
      {}
    ),
  getInfoMissing: () =>
    fetch(
      `${config.BACKEND_HOST_PACK_SERVICE}/get-info-missing`,
      "get",
      null,
      {}
    ),
  caring: (type) =>
    fetch(
      `${config.BACKEND_HOST_PACK_SERVICE}/caring-services?type=${type}`,
      "get",
      null,
      {}
    ),
  getCertInfoCapBu: () =>
    fetch(
      `${config.BACKEND_HOST_PACK_SERVICE}/renewcert/getinfomation-token`,
      "get",
      null,
      {}
    ),
  createTokenauthen: (tokenCode,seriCert) =>
      fetch(
          `${config.BACKEND_HOST_GATEWAY_SERVICE}/hmac/encrypt?tokenCode=${tokenCode}&serial=${seriCert}`,
          "get",
          null,
          {}
      ),
  checkrequestcapbu: (params={}) =>
    fetch(
      `${config.BACKEND_HOST_PACK_SERVICE}/renewcert/checkrequest-token`,
      "get",
      params,
      {}
    ),
  createrequestcapbu: (data = {}) =>
    fetch(
      `${config.BACKEND_HOST_PACK_SERVICE}/renewcert/createrequest-token-capbu`,
      "post",
      null,
      data,
      null
    ),
  getInformationOrder: (params) =>
    fetch(
      `${config.BACKEND_HOST_PACK_SERVICE}/renewcert/get-information-order`,
      "get",
      params,
      {}
    ),
  saveAndExportInvoice: (data) =>
    fetch(
      `${config.BACKEND_HOST_PACK_SERVICE}/renewcert/save-and-export-invoice`,
      "post",
      null,
      data,
      null
    ),
  updateActiveStatusForProgram: (data) =>
    fetch(
      `${config.BACKEND_HOST_PACK_SERVICE}/token-program/update-active-status-token-program`,
      "post",
      null,
      data,
      null
    ),
  updateStatusPayment: (data) =>
    fetch(
      `${config.BACKEND_HOST_PACK_SERVICE}/renewcert/update-status-payment`,
      "post",
      null,
      data,
      null
    ),
  getListPackageExtend: (params) =>
    fetch(
      `${config.BACKEND_HOST_PACK_SERVICE}/renewcert/get-list-package-extend`,
      "get",
      params,
      {},
      null
    ),
  saveDK01Signed: (data) =>
    fetch(
      `${config.BACKEND_HOST_PACK_SERVICE}/renewcert/save-dk01-signed`,
      "post",
      null,
      data,
      null
    ),
};

export default ServiceApi;
